import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_OooberthListComponent from "../components/_FM_oooberth/_FM_OooberthListComponent";
import _FM_OooberthFormComponent from "../components/_FM_oooberth/_FM_OooberthFormComponent";
import _FM_OooberthShowComponent from "../components/_FM_oooberth/_FM_OooberthShowComponent";
import _FM_BerthFormComponent from "../components/_FM_berth/_FM_BerthFormComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_OooberthPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();

  useEffect(() => {
    document.title = t('ooo_berths') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/oooberth')
  }, []);

  return (
    <div className="_FM_OooberthPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/oooberth"}/>
      <Panel>
        <_FM_OooberthListComponent/>
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/oooberth');
               }}>
        <_FM_OooberthFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/oooberth');
               }}>
        <_FM_OooberthShowComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'update' && entity === 'berth'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/oooberth');
               }}>
        <_FM_BerthFormComponent/>
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_OooberthPage);
